// test907
(907 && 0);
